import React from 'react'
import CompanyRow from './CompanyRow'

export default function CompanyTable({ companies }) {
  return (
    <div className='company-table-wrapper'>
      <table className="dome-table dome-table-striped" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Alias</th>
            <th>Logo</th>
            <th>Type</th>
            <th>Approval status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {companies && companies.map((company, key) => <CompanyRow key={key} company={company} />)}
        </tbody>
      </table>
    </div>
  )
}
